import { AddActivityMode } from 'app/constants/addActivityMode'

export const getAddActivityModeName = (type: AddActivityMode) => {
  let name = '-'

  switch (type) {
    case AddActivityMode.UNKNOWN:
      name = 'addActivityMode.unknown'
      break
    case AddActivityMode.UNKNOWN_REST:
      name = 'addActivityMode.unknown-rest'
      break
    case AddActivityMode.EACH_ACTIVITY:
      name = 'addActivityMode.each-activity'
      break
  }

  return name
}
